/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { LayoutControlContext } from './DetailedAvailabilityPageLayout';

function DetailedAvailabilityPageSide({ isItinerary, children }) {
    const { isFullView, isMobileApp } = useContext(LayoutControlContext);

    return (
        <section
            className={cx('per-availability-aside', {
                hide: isFullView,
                'mobile-app': isMobileApp,
                itinerary: isItinerary,
            })}
            role="complementary"
        >
            {children}
        </section>
    );
}

DetailedAvailabilityPageSide.propTypes = {
    isItinerary: PropTypes.bool,
    children: PropTypes.node,
};

export default DetailedAvailabilityPageSide;
